export const getAdditionalColumnProperties = (columnName: string, columnLength: number) => {
  const additionalProperties: Record<string, string> = {};
  for (let i = 0; i < columnLength; i++) {
    additionalProperties[`${columnName}${i}`] = '';
  }
  return additionalProperties;
};
